import script from "./TokenSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./TokenSelect.vue?vue&type=script&lang=ts&setup=true"

import "./TokenSelect.vue?vue&type=style&index=0&id=3531629f&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3531629f"]])

export default __exports__